export const CARRY_STRUCTURE_PATH = '/app/funds-carry/structure';

export const CARRY_STAK_PATH = `${CARRY_STRUCTURE_PATH}/stak`;

export const CARRY_COOPERATIVE_PATH = `${CARRY_STRUCTURE_PATH}/cooperative`;

export function carryStructureFundPath(fundId: string): string {
  return `${CARRY_STRUCTURE_PATH}/funds/${fundId}`;
}

export function carryHoldingPath(fundMemberId: string): string {
  return `${CARRY_STRUCTURE_PATH}/holdings/${fundMemberId}`;
}
